/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import FadeIn from 'react-fade-in';
import { LoadingButton } from '@mui/lab';
import Preloader from 'src/components/Preloader';
import { formatAmount } from 'src/utils/formatAmout';
import useStyles from '../styles';

const StepFour = ({ data, handleBack, handleSubmit, loading, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOtherSubmit = async e => {
    try {
      e.preventDefault();
      setIsSubmitting(true);
      await handleSubmit();
      setIsSubmitted(true);
    } catch (error) {
      console.error('Error submitting:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <Preloader />;
  }

  if (isSubmitted) {
    return (
      <FadeIn>
        <Box className={classes.container}>
          <Box style={{ padding: '10px', margin: '2rem 1rem' }}>
            <Typography style={{ fontSize: '20px' }}>
              {t('COMMON.CEDE_CONTRACT_EFFECT')}
            </Typography>
          </Box>
          <Box className={classes.box} display="flex" justifyContent="center">
            <Button
              className={clsx(classes.buttons, classes.buttonMain)}
              onClick={() => {
                handleClose();
                window.location.reload();
              }}
              color="primary"
              variant="contained"
            >
              {t('COMMON.ACCEPT')}
            </Button>
          </Box>
        </Box>
      </FadeIn>
    );
  }

  return (
    <FadeIn>
      <form onSubmit={handleOtherSubmit}>
        <Box className={classes.container}>
          <Box style={{ padding: '10px', margin: '2rem 1rem' }}>
            <Typography style={{ fontSize: '20px', marginBottom: 16 }}>
              <strong>{t('COMMON.CEDE_CONTRACT_BALANCE_TITLE')}</strong>
            </Typography>
            <Typography
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginBottom: 16
              }}
            >
              {`$${formatAmount(data.balance)}`}
            </Typography>
            <Typography style={{ marginBottom: 8 }}>
              {t('COMMON.CEDE_CONTRACT_BALANCE_TRANSFER_INFO')}
            </Typography>
            <Typography style={{ marginBottom: 8 }}>
              {t('COMMON.CEDE_CONTRACT_BALANCE_CREDIT_NOTE')}
            </Typography>
            <Typography>
              {t('COMMON.CEDE_CONTRACT_BALANCE_ACCEPT_INFO')}
            </Typography>
          </Box>
          <Box
            className={classes.box}
            display="flex"
            justifyContent="space-between"
          >
            <Button
              className={classes.buttons}
              onClick={handleBack}
              color="primary"
              variant="outlined"
              disabled={isSubmitting}
            >
              {t('COMMON.BACK')}
            </Button>
            <LoadingButton
              className={clsx(classes.buttons, classes.buttonMain)}
              type="submit"
              color="secondary"
              variant="contained"
              loadingPosition="start"
              loading={loading || isSubmitting}
              disabled={isSubmitting}
            >
              {t('COMMON.ACCEPT')}
            </LoadingButton>
          </Box>
        </Box>
      </form>
    </FadeIn>
  );
};

StepFour.propTypes = {
  data: PropTypes.object,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  handleClose: PropTypes.func
};

export default StepFour;
